// © Microsoft Corporation. All rights reserved.
export var ErrorBehavior;
(function (ErrorBehavior) {
    /** This app error can trigger exceptional behavior */
    ErrorBehavior[ErrorBehavior["Exceptional"] = 0] = "Exceptional";
    /** This app error can trigger fallback behavior */
    ErrorBehavior[ErrorBehavior["Fallback"] = 1] = "Fallback";
})(ErrorBehavior || (ErrorBehavior = {}));
//# sourceMappingURL=ErrorBehavior.js.map